const doUpsellAddToCart = function(data){
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
  .then(response => response.json()).then(res => {
    //console.log(res);
  }).catch(error => { console.error('An error occurred:', error); });
};
const upsellInit = () => {
  console.log('upsellInit');
  let upsellItems = document.querySelectorAll('.upsell div.upsellProducts > div.grid__item');
  console.log('upsellItems',upsellItems);
  for(let u=0;u<upsellItems.length;u++){
    let upsellSlug = upsellItems[u].getAttribute('data-product-handle');
    let selectedVariant = upsellItems[u].getAttribute('data-product-handle');
    let upsellVariantData = featuredVariants[upsellSlug];
    
    //add swatches
    for (let key in upsellVariantData) {
      if (upsellVariantData.hasOwnProperty(key)) {
        let el = document.createElement('div');
        el.classList.add('upsellSwatch');
        if(upsellVariantData[key]==upsellSlug) el.classList.add('activeSwatch');
        el.setAttribute('data-variant-id',upsellProducts[upsellVariantData[key]].data.id);
        el.setAttribute('data-selected-variant',upsellVariantData[key]);
        let img = document.createElement('img');
        img.title = upsellProducts[upsellVariantData[key]].name;
        img.src = upsellProducts[upsellVariantData[key]].chip;
        el.append(img);
        upsellItems[u].querySelector('.grid-product-swatches').append(el);
      }
    }
    
    //add click events for swatches
    let swatchesEls = upsellItems[u].querySelectorAll('.upsellSwatch');
    for (let r = 0; r < swatchesEls.length; r++) {
      swatchesEls[r].addEventListener('click', function () {
        if (swatchesEls[r].classList.contains('disabled')) {
          return; // Exit if the element is disabled
        }
        // Disable all swatches to prevent further clicks
        for (let i = 0; i < swatchesEls.length; i++) {
          swatchesEls[i].classList.add('disabled');
        }
        // Perform the necessary actions
        upsellItems[u].querySelector('.upsellSwatch.activeSwatch').classList.remove('activeSwatch');
        swatchesEls[r].classList.add('activeSwatch');
        let selectedSwatch = swatchesEls[r].getAttribute('data-selected-variant');
        upsellItems[u].querySelector('.grid-product__title').textContent = upsellProducts[selectedSwatch].data.title;
        let formattedNumber = (upsellProducts[selectedSwatch].data.price / 100).toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD',
        });
        upsellItems[u].querySelector('.grid-product__price > span > span.igPrice').textContent = formattedNumber;
        upsellItems[u].setAttribute('data-product-handle', selectedSwatch);
        upsellItems[u].setAttribute('data-product-id', upsellProducts[selectedSwatch].data.id);
        upsellItems[u].querySelector('.grid-product__image').setAttribute('data-srcset', '');
        upsellItems[u].querySelector('.grid-product__image').setAttribute('srcset', '');
        upsellItems[u].querySelector('.grid-product__image').src = upsellProducts[selectedSwatch].data.featured_image;
        upsellItems[u].querySelector('.mobilePrice').innerHTML = '<span><span class="igPrice">' + formattedNumber + '</span></span>';
        if (!upsellItems[u].querySelector('.addtc-dropdown-upsell').classList.contains('ac_hide')) {
          upsellItems[u].querySelector('.addtc-dropdown-upsell').innerHTML = '';
          let thisQuickAdd = upsellItems[u].querySelector('.upsell_quickAdd');
          let qaID = thisQuickAdd.getAttribute('id');
          doBuildOptions(thisQuickAdd, qaID, 'swatch');
        }
        // Re-enable swatches after a brief delay
        setTimeout(() => {
          for (let i = 0; i < swatchesEls.length; i++) {
            swatchesEls[i].classList.remove('disabled');
          }
        }, 500); // Adjust the delay as necessary
      });
    }
    
    let optionCount = 0;
    const doBuildOptions = (thisQuickAdd,qaID,type) => {
      optionCount = 0;
      let selectedVariantSlug = (qaID === 'd1') ? upsellSlug : thisQuickAdd.parentElement.querySelector('div.grid-product-swatches div.activeSwatch').getAttribute('data-selected-variant');
      let variantOptions = upsellProducts[selectedVariantSlug].data.variants;
      for (let option in variantOptions) {
        if(variantOptions[option].available){
          let el = document.createElement('li');
          el.setAttribute('data-selling-plan-id','');
          el.setAttribute('data-id',variantOptions[option].id);
          el.setAttribute('data-handle',selectedVariantSlug);
          el.setAttribute('title',variantOptions[option].title);
          let spanel = document.createElement('span');
          spanel.textContent = variantOptions[option].title;
          el.appendChild(spanel);
          upsellItems[u].querySelector('.addtc-dropdown-upsell').appendChild(el);
          optionCount++;
        }
      }
      if(optionCount > 0){
        let sizeSelector = document.querySelectorAll('li[data-handle="'+selectedVariantSlug+'"]');
        for(let f=0;f<sizeSelector.length;f++){
          sizeSelector[f].addEventListener('click',function(){
            gtag('event', 'UN68_CrossSellClicks', {
              event_label: sizeSelector[f].getAttribute('data-handle')+'|'+sizeSelector[f].getAttribute('title'),
              send_to: ['G-7PXWPB472Y'],
            });
            let formData = { 'items': [] };
            formData.items.push({'id':sizeSelector[f].getAttribute('data-id'),'quantity':1});
            doUpsellAddToCart(formData);
            sizeSelector[f].parentElement.classList.add('ac_hide');
            sizeSelector[f].parentElement.innerHTML = '';
          });
        }
        if(upsellItems[u].querySelector('.addtc-dropdown-upsell').classList.contains('sold_out')) {
          upsellItems[u].querySelector('.addtc-dropdown-upsell').classList.remove('sold_out');
        }
      } else {
        if(!upsellItems[u].querySelector('.addtc-dropdown-upsell').classList.contains('sold_out')) {
          upsellItems[u].querySelector('.addtc-dropdown-upsell').classList.add('sold_out');
        }
      }
      if(type === 'qadd'){
        if(upsellItems[u].querySelector('.addtc-dropdown-upsell').classList.contains('ac_hide')) {
          upsellItems[u].querySelector('.addtc-dropdown-upsell').classList.remove('ac_hide');
        }
      }
    };
    //add click events for quick add buttons
    let thisQuickAdd = upsellItems[u].querySelector('.upsell_quickAdd');
    if(thisQuickAdd){
      let qaID = thisQuickAdd.getAttribute('id');
      thisQuickAdd.addEventListener('click',function(){
        if(thisQuickAdd.parentElement.querySelector('.addtc-dropdown-upsell').classList.contains('ac_hide')) doBuildOptions(thisQuickAdd,qaID,'qadd');
      });
      upsellItems[u].querySelector('.addtc-dropdown-upsell').addEventListener('click',function(e){
        if(e.srcElement.localName === 'ul'){
          upsellItems[u].querySelector('.addtc-dropdown-upsell').innerHTML = '';
          upsellItems[u].querySelector('.addtc-dropdown-upsell').classList.add('ac_hide');
        }
      });
    }    
  }
  
};

let upsellFetchPromises = [];
for (let upsell in upsellProducts) {
  let upsellFetchPromise = fetch(window.Shopify.routes.root + 'products/' + upsell + '.js')
    .then(response => {
      if (!response.ok) throw new Error(`Fetch failed for ${upsell}`);
      return response.json();
    })
    .then(product => {
      upsellProducts[upsell].data = product;
    })
    .catch(error => {
      console.error('An error occurred:', error);
    });
  upsellFetchPromises.push(upsellFetchPromise);
}
Promise.all(upsellFetchPromises).then(() => {
  upsellInit();
  //preload images to prevent delay on swatch click
  for (let key in upsellProducts) {
    if (upsellProducts.hasOwnProperty(key)) {
      let product = upsellProducts[key];
      if (product.data && product.data.featured_image) {
        let img = new Image();
        img.src = product.data.featured_image.startsWith('http') ? product.data.featured_image : `https:${product.data.featured_image}`;
      }
    }
  }
});